import {
  FilterType,
  buildPerformanceReviewsDataTableFilter,
  usePerformanceReviewsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const participationRateFilter = (source: ReturnType<typeof usePerformanceReviewsDataTable>) => {
  return buildPerformanceReviewsDataTableFilter(source, {
    identifier: 'participationRate',
    title: i18n.t('performance_process.reviews.datatable.participation_rate'),
    path: 'participationRate',
    type: FilterType.Integer,
    categories: [
      {
        kind: 'RangePicker',
        operation: 'between',
        range: [0, 100],
        value: [0, 100],
      },
    ],
  })
}

export default participationRateFilter
